import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import CommonToast from "../../../../components/_utils/CommonToast";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import {
  ReimburseApproveAccount,
  ReimburseRejectAccount,
  viewAccountDetailR,
} from "../../../../redux/features/accounts/ReimburseAccount";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import {
  bankLookUp,
  panLookUp,
} from "../../../../redux/features/sharedResources/sharedResources";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { linkIdentifier } from "../../../../utils/linkIdentifier";

const CreateSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [rejectPopup, setRejectPopup] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [declineReason, setDeclineReason] = useState("");

  const services = useSelector((state) => state.refreshToken.services);

  const { viewAccountDetailData } = useSelector(
    (state) => state.ReimburseAccount,
  );

  const beneLookData = useSelector(
    (state) => state.sharedResources.panLookupData,
  );

  const benebankLookData = useSelector(
    (state) => state.sharedResources.bankLookupData,
  );

  const accountData = viewAccountDetailData?.reimbursement_accounts?.[0];

  useEffect(() => {
    dispatch(viewAccountDetailR({ id }));
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [id, dispatch]);

  useEffect(() => {
    if (!accountData) return;

    dispatch(panLookUp({ pan_number: accountData.pan_no }));

    dispatch(
      bankLookUp({
        ifsc: accountData.ifsc_code,
        bank_account_no: accountData.bank_acc_no,
      }),
    );
  }, [accountData, dispatch]);

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const approveAcc = async () => {
    try {
      UniversalRefreshToast("approvalaccountsRefresh");
      let response = await dispatch(ReimburseApproveAccount(id)).unwrap();
      if (response?.status === false || response === undefined) {
        let error_msg = "";
        if (response?.errors?.reimbursement_account?.[0]) {
          error_msg = response.errors.reimbursement_account?.[0];
        } else if (response?.errors?.bank_account_number?.[0]) {
          error_msg = response.errors.bank_account_number?.[0];
        } else {
          error_msg = "An unknown error occurred.";
        }
        toast.dismiss();
        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text_primary)",
            enabledBgColor: "var(--primary_bg)",
          },
        });
      } else {
        toast.dismiss();
        navigate(
          `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
          {
            replace: true,
          },
        );
        const successMessage = "Account approved successfully.";
        CommonToast({
          text: successMessage,
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } catch (err) {
      console.error("Approval failed", err);
      let error_msg = "";
      if (err?.errors?.reimbursement_account?.[0]) {
        error_msg = err.errors.reimbursement_account?.[0];
      } else if (err?.errors?.bank_account_number?.[0]) {
        error_msg = err.errors.bank_account_number?.[0];
      } else {
        error_msg = "An unknown error occurred.";
      }
      toast.dismiss();
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
  };
  const rejectAcc = async ({ id, AccountIdData: accountIdData }) => {
    try {
      UniversalRefreshToast("accountsRefresh");
      let response = await dispatch(
        ReimburseRejectAccount({ id, AccountIdData: accountIdData }),
      );
      if (
        response?.payload?.status === false ||
        response?.payload === undefined
      ) {
        toast.dismiss();
        let error_msg = "";
        let error_list = null;
        if (response === undefined) {
          error_msg = "An error occured while taking action on this account";
        } else if (response?.payload?.errors?.reimbursement_account) {
          if (
            response?.payload?.errors?.reimbursement_account?.length >
            GlobalConfiguration?.lengthCheckOne
          ) {
            error_list = response?.payload?.errors?.reimbursement_account;
          } else {
            error_msg = response?.payload?.errors?.reimbursement_account?.[0];
          }
        } else if (response?.payload?.status === false) {
          error_msg = response?.payload?.errors?.category?.[0];
        } else if (response?.payload?.errors?.bank_account_number?.[0]) {
          error_msg = response?.payload?.errors?.bank_account_number?.[0];
        } else if (response?.payload?.errors?.base) {
          error_msg = response?.payload?.errors?.base?.[0];
        }

        if (
          Array.isArray(error_list) &&
          error_list.length > GlobalConfiguration?.lengthCheckOne
        ) {
          error_list.forEach((err) => {
            CommonToast({
              text: err,
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text_primary)",
                enabledBgColor: "var(--primary_bg)",
              },
            });
          });
        } else {
          CommonToast({
            text: error_msg,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text_primary)",
              enabledBgColor: "var(--primary_bg)",
            },
          });
        }
        setShowLoader(false);
      } else {
        toast.dismiss();
        navigate(
          `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
          {
            replace: true,
          },
        );
        CommonToast({
          text: "Account rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
      setRejectPopup(false);
      setDeclineReason("");
    } catch (err) {
      console.error("Rejected failed", err);
    }
  };

  const createAccountHandler = () => {
    navigate("/reimbursement_account_dashboard/create_reimbursement_account", {
      replace: true,
    });
  };

  const viewDetailsHandler = () => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
      {
        replace: true,
      },
    );
  };

  const dashboardHandler = () => {
    navigate("/reimbursement_account_dashboard", {
      replace: true,
    });
  };

  const buttonRows = [
    ...(services?.includes("RAAccount") || services?.includes("Admin")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              handleFunction: () => {
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              handleFunction: () => {
                approveAcc();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
          ],
        ]
      : []),

    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.CREATE_NEW_ACCOUNT,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      // {
      //   btnText: "Create transaction",
      //   enabledBgColor: "var(--text-primary)",
      //   enabledTextColor: "var(--positive-bg)",
      //   icon: ICONS.ADD_BUTTON_WHITE,
      //   handleFunction: createTxnHandler,
      //   iconToBeAlign: "left",
      //   fullWidthRequired: true,
      //   imgColor: "var(--positive-bg)",
      // },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],

    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];
  const handleInputChange = (event) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    setDeclineReason(sanitizedValue);
  };
  const AccountIdData = declineReason;

  return (
    <div>
      {rejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex">
          <div className="absolute top-top-base left-top-base h-full w-full bg-PopUp-BackDrop opacity-dark-opacity" />
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejection."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText="Minimum 10 characters required."
            noteColor="text-secondary"
            inputPlaceholder="Reason"
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              setRejectPopup(false);
              setDeclineReason("");
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              setShowLoader(true);
              rejectAcc({ id, AccountIdData });
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              declineReason.trim().length <
              GlobalConfiguration.rejectReasonMinLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={
          location?.state?.type === "switch_account"
            ? "Beneficiary account successfully switched to reimbursement account"
            : "Reimbursement account created successfully and awaiting approval."
        }
      >
        <TabsWeapperSection title="Account details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.name,
                  leftTitleTextFontSize: "font-md",
                  leftSubTitle:
                    accountData?.name === accountData?.pan_legal_name
                      ? "Account name - Using legal name"
                      : "Account name",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.bank_acc_no,
                  leftSubTitle: "Account number",
                  ifsc: accountData?.ifsc_code,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.ifsc_code,
                  leftSubTitle: "IFSC code",
                },
              ]}
            />
            {accountData?.virtual_account === "Y" && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle:
                      accountData?.virtual_account_type === "manual"
                        ? "Manually created"
                        : "Auto detected",
                    leftSubTitle: "Virtual account",
                  },
                ]}
              />
            )}
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.category_ids
                    ?.map((x) => x.category_name)
                    .join(","),
                  leftSubTitle: "Categories",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.pan_no,
                  leftSubTitle: "PAN number",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.gstin_detail ?? "Not given",
                  leftSubTitle: "GST number (optional)",
                },
              ]}
            />
            {accountData?.reimbursement_user_full_name &&
            accountData?.reimbursement_identifier ? (
              <>
                <InfoCard
                  bgColor="var(--positive-card)"
                  showRowDivider={
                    accountData?.reimbursement_identifier ? true : false
                  }
                  rowBorderColor="var(--positive-bg)"
                  rows={[
                    {
                      leftTitle:
                        accountData?.reimbursement_user_full_name ??
                        "Not linked",
                      leftSubTitle: "Username (optional)",
                    },
                    {
                      leftTitle: accountData?.reimbursement_identifier,
                      leftSubTitle: "User ID",
                    },
                  ]}
                />
              </>
            ) : (
              <>
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: "Not linked",
                      leftSubTitle: "Username (optional)",
                    },
                  ]}
                />
              </>
            )}
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.contact_no,
                  leftSubTitle: "Contact number",
                  icon: ICONS?.CONTACT_WITH_WHITE_CIRCLE,
                  iconSize: "small",
                  bgNeeded: false,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: linkIdentifier(accountData?.email_id),
                  leftSubTitle: "Email ID",
                  icon: ICONS?.CONTACT_US_MAIL,
                  iconSize: "small",
                  bgNeeded: false,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.labels
                    ? accountData.labels.join(",")
                    : "Not assigned",
                  leftSubTitle: "Labels (optional)",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.recipient_email
                    ? linkIdentifier(accountData?.recipient_email.join(", "))
                    : "Not given",
                  leftSubTitle: "Recipents (optional)",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.id,
                  leftSubTitle: "Account ID",
                  copyText: accountData?.id,
                },
              ]}
            />
          </>
        </TabsWeapperSection>
        {beneLookData?.beneficiary_accounts.length >
          GlobalConfiguration.lengthCheckOne && (
          <TabsWeapperSection title="Accounts associated to PAN">
            {beneLookData?.beneficiary_accounts
              ?.filter(
                (accountData) =>
                  accountData?.approval_status === "pending" ||
                  accountData?.approval_status === "approved",
              )
              .map((accountData, id) => (
                <InfoCard
                  key={id}
                  bgColor="var(--positive-card)"
                  header={true}
                  borderColor="var(--positive-bg)"
                  rightHeaderText={`${
                    accountData?.approval_status?.charAt(0).toUpperCase() +
                    accountData?.approval_status?.slice(1)
                  } account`}
                  leftHeaderText={accountData?.bank_account_holder_full_name}
                  leftHeaderWidth="w-width-lg"
                  rows={[
                    {
                      leftTitle: accountData?.bank_acc_no,
                      leftSubTitle: "Bank account number",
                      ifsc: accountData?.ifsc_code,
                    },
                  ]}
                />
              ))}
          </TabsWeapperSection>
        )}

        {benebankLookData?.beneficiary_accounts?.length >
          GlobalConfiguration.lengthCheckOne && (
          <TabsWeapperSection title="Accounts associated to bank">
            {benebankLookData?.beneficiary_accounts
              .filter(
                (accountData) =>
                  accountData?.approval_status === "pending" ||
                  accountData?.approval_status === "approved",
              )
              .map((accountData, id) => (
                <InfoCard
                  key={id}
                  bgColor="var(--positive-card)"
                  header={true}
                  borderColor="var(--positive-bg)"
                  rightHeaderText={`${
                    accountData?.approval_status?.charAt(0).toUpperCase() +
                    accountData?.approval_status?.slice(1)
                  } account`}
                  leftHeaderText={accountData?.name}
                  showTopArrow={false}
                  rows={[
                    {
                      leftTitle: accountData?.pan_no,
                      leftSubTitle: "PAN number",
                    },
                  ]}
                />
              ))}
          </TabsWeapperSection>
        )}
      </StatusContainer>
    </div>
  );
};

export default CreateSuccess;
